<script>
export default {
  name: "newWarehouseTypeIcon",
};
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_1255_8691)">
      <path
        d="M16.25 19.5H3.75C2.88805 19.5 2.0614 19.1576 1.4519 18.5481C0.84241 17.9386 0.5 17.112 0.5 16.25V3.75C0.5 2.88805 0.84241 2.0614 1.4519 1.4519C2.0614 0.84241 2.88805 0.5 3.75 0.5H16.25C17.112 0.5 17.9386 0.84241 18.5481 1.4519C19.1576 2.0614 19.5 2.88805 19.5 3.75V16.25C19.5 17.112 19.1576 17.9386 18.5481 18.5481C17.9386 19.1576 17.112 19.5 16.25 19.5Z"
        fill="white"
        stroke="#DFE2E9"
      />
      <path
        d="M15.8425 8.06917L10.2175 4.06926C10.1541 4.0242 10.0782 4 10.0004 4C9.92257 4 9.84669 4.0242 9.78325 4.06926L4.15825 8.06917C4.10931 8.10361 4.06937 8.14933 4.04183 8.20247C4.01428 8.2556 3.99994 8.31458 4 8.37443V10.1243C3.99978 10.1932 4.0186 10.2609 4.05439 10.3198C4.09019 10.3787 4.14156 10.4266 4.20285 10.4582C4.26414 10.4898 4.33296 10.5038 4.40171 10.4987C4.47047 10.4937 4.5365 10.4697 4.5925 10.4295L5.0005 10.1393V15.499C5.0003 15.5647 5.01308 15.6298 5.03809 15.6906C5.06311 15.7514 5.09987 15.8066 5.14627 15.8532C5.19267 15.8997 5.2478 15.9366 5.3085 15.9618C5.3692 15.987 5.43428 16 5.5 16H6.49975V9.99975H13.4995V16H14.5C14.6327 16 14.7599 15.9473 14.8537 15.8535C14.9475 15.7597 15.0002 15.6324 15.0002 15.4997V10.14L15.4082 10.4303C15.4644 10.4694 15.5303 10.4925 15.5986 10.4971C15.667 10.5016 15.7352 10.4874 15.7961 10.456C15.857 10.4246 15.9082 10.3772 15.9441 10.3188C15.98 10.2605 15.9993 10.1935 16 10.125V8.37518C16.0001 8.31531 15.9858 8.25628 15.9584 8.20304C15.931 8.1498 15.8913 8.1039 15.8425 8.06917Z"
        fill="#7A889B"
      />
      <path
        d="M7 14.8093H13V16H7V14.8093ZM7 12.905H13V14.0957H7V12.905ZM7 11H13V12.1907H7V11Z"
        fill="#BDC5D1"
      />
    </g>
    <defs>
      <clipPath id="clip0_1255_8691">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped></style>
